import { getRsftWelcomeMessageCappedPageCount } from "./getRsftWelcomeMessageCappedPageCount";
import { setRsftWelcomeMessageCappedPageCount } from "./setRsftWelcomeMessageCappedPageCount";

const SHOW_RSFT_WELCOME_MESSAGE_PAGE_COUNT_THRESHOLD = 2;

export const getIsPageCountHighEnough = () => {
  const currentCappedPageCount = getRsftWelcomeMessageCappedPageCount();

  if (currentCappedPageCount < SHOW_RSFT_WELCOME_MESSAGE_PAGE_COUNT_THRESHOLD) {
    setRsftWelcomeMessageCappedPageCount(currentCappedPageCount + 1);

    return false;
  }

  return true;
};
